export default "__VITE_ASSET__Dtwg3_XP__"